import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import {
  Box,
  Card,
  CardContent,
  Typography,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  CircularProgress,
  Alert,
} from '@mui/material'
import { Add as AddIcon, Visibility as VisibilityIcon } from '@mui/icons-material'
import { reportsApi } from '../lib/api'
import { LearningReport } from '../types'

export default function Reports() {
  const navigate = useNavigate()
  const [reports, setReports] = useState<LearningReport[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')

  useEffect(() => {
    loadReports()
  }, [])

  const loadReports = async () => {
    try {
      const data = await reportsApi.getAll()
      setReports(data)
    } catch (err: any) {
      setError(err.message || '加载报告失败')
    } finally {
      setLoading(false)
    }
  }

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 8 }}>
        <CircularProgress />
      </Box>
    )
  }

  return (
    <Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Typography variant="h4">学情报告</Typography>
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={() => navigate('/analysis')}
        >
          新建分析
        </Button>
      </Box>

      {error && (
        <Alert severity="error" sx={{ mb: 3 }}>
          {error}
        </Alert>
      )}

      {reports.length === 0 ? (
        <Card>
          <CardContent sx={{ textAlign: 'center', py: 8 }}>
            <Typography variant="h6" color="text.secondary" gutterBottom>
              暂无学情报告
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
              上传作业图片并完成分析后，系统将自动生成学情报告
            </Typography>
            <Button variant="contained" onClick={() => navigate('/analysis')}>
              开始分析
            </Button>
          </CardContent>
        </Card>
      ) : (
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>报告ID</TableCell>
                <TableCell>学生ID</TableCell>
                <TableCell>任务ID</TableCell>
                <TableCell>生成时间</TableCell>
                <TableCell align="right">操作</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {reports.map(report => (
                <TableRow key={report.id} hover>
                  <TableCell sx={{ fontFamily: 'monospace' }}>{report.id.slice(0, 8)}...</TableCell>
                  <TableCell>{report.studentId}</TableCell>
                  <TableCell sx={{ fontFamily: 'monospace' }}>{report.taskId.slice(0, 8)}...</TableCell>
                  <TableCell>{new Date(report.createdAt).toLocaleString()}</TableCell>
                  <TableCell align="right">
                    <Button
                      size="small"
                      startIcon={<VisibilityIcon />}
                      onClick={() => navigate(`/reports/${report.id}`)}
                    >
                      查看
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Box>
  )
}
